export default __webpack_public_path__ + "static/123-bc69c725a4c80505acf64a470429e0d0.jpg";